import AuditActivityScreen from './screens/auditactivity-screen';
import { RouteDefinition } from '../../core/route';

export const auditactivityRoutes: RouteDefinition[] = [
  {
    id: 'AuditActivityList',
    title: 'Audit Activity',
    path: 'audit-activity',
    element: <AuditActivityScreen />,
    showInNavigation: true,
  },
];
